module.exports = __webpack_public_path__ + "static/media/ic-user.cf4a84bf.svg";